export const setStateChart = (isLoaded=false) =>{
    return {
        type:'SET_STATE_CHART',
        payload:isLoaded
    }
}


export const setInitValuesChartLine = (querySelection) => {
    return{
        type:'SET_QUERY_VALUES_CHART_LINE',
        payload: querySelection
    }
}


export const setValuesItemChartLine  = (code, values) => {
    return{
        type: 'SET_STATUS_CHECK_CHART_LINE',
        payload: {
            values,
            code
        }
    }
}

export const setQueryAllValuesChartLine = (code) => {
    return {
        type: 'SET_QUERY_ALL_VALUES_CHART_LINE',
        payload: code
    }
}

